// 数据控制中心

// 主页
import Dkb from '@/components/DkbPage/Dkb'

// 小屏（卡片列表）模块
import SScreen from '@/components/DkbPage/SScreen/SScreen'
// 全屏模块
import FScreen from '@/components/DkbPage/FScreen/FScreen'

let rv = 0, psdWidth = 1920
let router = [
  // 主页
  {
    path: '/Dkb',
    name: 'Dkb',
    component: Dkb,
    meta: {
      title: '数据控制中心',
      rv: rv,
      psdWidth: psdWidth
    },
    children: [
      // 小屏（卡片列表）模块
      {
        path: '',
        name: 'DkbSScreen',
        component: SScreen,
        meta: {
          title: '数据控制中心',
          rv: rv,
          psdWidth: psdWidth
        }
      },
      // 全屏模块
      {
        path: 'FScreen/:name',
        name: 'DkbFScreen',
        component: FScreen,
        meta: {
          title: '数据控制中心',
          rv: rv,
          psdWidth: psdWidth
        }
      },
      // 全屏模块-内容全屏
      {
        path: 'FScreen/:name/:content',
        name: 'DkbFScreenContent',
        component: FScreen,
        meta: {
          title: '数据控制中心',
          rv: rv,
          psdWidth: psdWidth
        }
      },
    ]
  },
  // 主页-绿瘦集团专用
  {
    path: '/DkbLS',
    name: 'DkbLvshou',
    component: Dkb,
    meta: {
      title: '数据控制中心',
      rv: rv,
      psdWidth: psdWidth
    },
    children: [
      // 全屏模块-绿瘦集团专用
      {
        path: '',
        name: 'DkbFScreenLvshou',
        component: FScreen,
        meta: {
          title: '数据控制中心',
          rv: rv,
          psdWidth: psdWidth,
          LSS: true   // 是否是绿瘦专用
        }
      },
    ]
  }
]

export default router


// WEBPACK FOOTER //
// ./src/router/modules/DkbPage.js